module.exports = __webpack_public_path__ + "assets/img/11_478_big.8ca2f243.jpg";